import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { fillRule: "evenodd", d: "M4 1H3v22h18V6.6l-.3-.3-5-5-.3-.3H4Zm1 20V3h9v5h5v13H5ZM17.6 6 16 4.4V6h1.6Z", clipRule: "evenodd" }));
export {
  l as ReactComponent
};
